// Tabla de correspondencia resto -> letra
const DNI_LETTERS = {
  0: 'T', 1: 'R', 2: 'W', 3: 'A', 4: 'G', 5: 'M', 6: 'Y', 7: 'F', 8: 'P', 9: 'D', 10: 'X', 11: 'B',
  12: 'N', 13: 'J', 14: 'Z', 15: 'S', 16: 'Q', 17: 'V', 18: 'H', 19: 'L', 20: 'C', 21: 'K', 22: 'E'
};

// Tabla de correspondencia letra -> número para NIE
const NIE_LETTERS = {
  'X': '0',
  'Y': '1',
  'Z': '2'
};

/**
 * Valida un DNI español
 * @param {string} dni - DNI a validar (formato: 8 números + letra)
 * @returns {boolean} - true si el DNI es válido, false si no lo es
 */
export function validateDNI(dni) {
  if (!dni) return false;
  
  // Convertir a mayúsculas y eliminar espacios
  dni = dni.toUpperCase().trim();
  
  // Verificar formato básico (8 números + letra)
  if (!/^[0-9]{8}[A-Z]$/.test(dni)) return false;
  
  // Obtener números y letra
  const numbers = dni.substring(0, 8);
  const letter = dni.substring(8);
  
  // Calcular resto
  const remainder = parseInt(numbers) % 23;
  
  // Verificar letra
  return DNI_LETTERS[remainder] === letter;
}

/**
 * Valida un NIE español
 * @param {string} nie - NIE a validar (formato: letra + 7 números + letra)
 * @returns {boolean} - true si el NIE es válido, false si no lo es
 */
export function validateNIE(nie) {
  if (!nie) return false;
  
  // Convertir a mayúsculas y eliminar espacios
  nie = nie.toUpperCase().trim();
  
  // Verificar formato básico (letra + 7 números + letra)
  if (!/^[XYZ][0-9]{7}[A-Z]$/.test(nie)) return false;
  
  // Obtener letra inicial, números y letra final
  const initialLetter = nie.substring(0, 1);
  const numbers = nie.substring(1, 8);
  const finalLetter = nie.substring(8);
  
  // Convertir letra inicial a número
  const convertedNumber = NIE_LETTERS[initialLetter] + numbers;
  
  // Calcular resto
  const remainder = parseInt(convertedNumber) % 23;
  
  // Verificar letra
  return DNI_LETTERS[remainder] === finalLetter;
}

/**
 * Valida un DNI o NIE español
 * @param {string} document - DNI o NIE a validar
 * @returns {boolean} - true si el documento es válido, false si no lo es
 */
export function validateDNIorNIE(document) {
  if (!document) return false;
  
  // Convertir a mayúsculas y eliminar espacios
  document = document.toUpperCase().trim();
  
  // Verificar si es DNI o NIE según el formato
  if (/^[0-9]{8}[A-Z]$/.test(document)) {
    return validateDNI(document);
  } else if (/^[XYZ][0-9]{7}[A-Z]$/.test(document)) {
    return validateNIE(document);
  }
  
  return false;
}

/**
 * Calcula la letra de control para un DNI
 * @param {string} numbers - 8 números del DNI
 * @returns {string} - Letra de control
 */
export function calculateDNILetter(numbers) {
  if (!/^[0-9]{8}$/.test(numbers)) return null;
  const remainder = parseInt(numbers) % 23;
  return DNI_LETTERS[remainder];
}

/**
 * Calcula la letra de control para un NIE
 * @param {string} nie - NIE sin letra final (formato: letra + 7 números)
 * @returns {string} - Letra de control
 */
export function calculateNIELetter(nie) {
  if (!/^[XYZ][0-9]{7}$/.test(nie)) return null;
  const initialLetter = nie.substring(0, 1);
  const numbers = nie.substring(1);
  const convertedNumber = NIE_LETTERS[initialLetter] + numbers;
  const remainder = parseInt(convertedNumber) % 23;
  return DNI_LETTERS[remainder];
} 